// UserDashps.js
import React, { useState } from 'react';
import axios from 'axios';
import "./UserDashPsUtilStyle.css"
import LocalStorageUtil from './LocalStorageUtil';

const UserDashps = ({ session, baseHostUrl }) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');

  const handleChangePassword = async () => {

    if (!oldPassword || !newPassword) {
      setMessage('Please fill in both fields.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setMessage('New passwords do not match.');
      return;
    }

    try {
      const response = await axios.post(`${baseHostUrl}/update-userpsd`, {
        username: session.username,
        oldPassword,
        newPassword
      }, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      });

      setMessage(response.data || 'Password updated successfully.');
      setOldPassword('');
      setNewPassword('');
      setConfirmPassword('');
    } catch (err) {
      setMessage('Failed to update password. Please check your old password.');
    }
  };

  return (
    <div className="db-password-container">
      <h4 className="db-password-title">Change Password</h4>
      <input
        className="db-password-input"
        type="password"
        placeholder="Old Password"
        value={oldPassword}
        onChange={(e) => setOldPassword(e.target.value)}
      />
      <input
        className="db-password-input"
        type="password"
        placeholder="New Password"
        value={newPassword}
        onChange={(e) => setNewPassword(e.target.value)}
      />
      <input
        className="db-password-input"
        type="password"
        placeholder="Confirm New Password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
      />
      {message && <p className="db-password-message">{message}</p>}
      <button className="db-password-button" onClick={handleChangePassword}>Update Password</button>
    </div>
  );

};

export default UserDashps;
